import { StarIcon } from "@/components/RFIcon";
import clsx from "clsx";
import { useEffect, useState } from "react";
interface NTFAvatarStarFilterProps {
	initial: number[];
	labelText: string;
	onSelected: (params: number[]) => void;
}

const InitialStar = new Array(5).fill(undefined).map((item, index) => {
	return {
		star: 5 - index,
		selected: false,
	};
});

export default function NTFAvatarStarFilter(props: NTFAvatarStarFilterProps) {
	const [stars, setStars] = useState([...InitialStar]);

	useEffect(() => {
		stars.forEach((star) => {
			if (props.initial.includes(star.star)) {
				star.selected = true;
			} else {
				star.selected = false;
			}
		});

		setStars([...stars]);
	}, [props.initial]);

	const onStarBtnClick = (selected: boolean, _index: number) => {
		const _stars = stars;
		_stars.forEach((item, index) => {
			if (index === _index) {
				item.selected = !selected;
			}
		});
		setStars([..._stars]);
		const onSelectedStars = _stars.filter((item) => item.selected).map((item) => item.star);

		props.onSelected(onSelectedStars);
	};
	return (
		<ul className="flex items-center justify-between w-full mt-3.5 px-4 pb-3.5">
			{stars.map((item, index) => (
				<li
					key={item.star}
					className={clsx(
						"flex h-8 border-[0.7px] items-center text-sm font-bold rounded-full flex-1 justify-center mr-1.5 last-of-type:mr-0",
						item.selected
							? "bg-primary  border-primary text-white dark:border-white dark:text-dark dark:bg-white"
							: "bg-white  text-b2b2b2 border-e5e5e5 dark:bg-dark dark:text-white dark:border-black_2e",
					)}
					onClick={() => onStarBtnClick(item.selected, index)}
				>
					<StarIcon className="w-3 h-3 mr-1" />
					<span>x</span>
					<span>{item.star}</span>
				</li>
			))}
		</ul>
	);
}
